import { setSnackbarForEndpoint } from "../../utils/snackbar";
import { sepAPI } from "../API/sepAPI";
import {
  EmailNotificationLocation,
  EmailNotificationLocationUpdateBody,
} from "../../../shared/types/EmailNotificationLocation";

export const EmailNotificationLocationSlice = sepAPI.injectEndpoints({
  endpoints: (builder) => ({
    createEmailNotificationLocation: builder.mutation<
      EmailNotificationLocation,
      { body: any }
    >({
      query: (data) => {
        const { body } = data;
        return {
          url: `email-notification-location`,
          method: "POST",
          body: body,
        };
      },
      invalidatesTags: ["EmailNotificationLocation", "TaskTemplate"],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          successMessage: "Email notification location created successfully!",
          errorMessage: "There was a problem creating your email notification location.",
        });
      },
    }),

    deleteEmailNotificationLocation: builder.mutation<
      void,
      { id: number }
    >({
      query: (data) => {
        const { id } = data;
        return {
          url: `email-notification-location/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["EmailNotificationLocation", "TaskTemplate"],
      onQueryStarted: (arg, api) => {
        setSnackbarForEndpoint(api, {
          successMessage: "Email notification location deleted successfully!",
          errorMessage: "There was a problem deleting your email notification location.",
        });
      },
    }),
  }),
});

export const {
  useCreateEmailNotificationLocationMutation,
  useDeleteEmailNotificationLocationMutation,
} = EmailNotificationLocationSlice;
